import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useNavigateWithQuery } from '../../../helpers/useNavigationWithQuery'

import { Animal } from "../../../types/rtk/animal/animal";
import Container from "../../templates/Container/Container";
import Header from "../../templates/Header/Header";
import { AppRoutes } from "../../../routes/AppRoutes";
import Title from "../../atoms/Title/Title";
import First from "../../molecules/First/First";
import Seconde from "../../molecules/Seconde/Seconde";
import Third from "../../molecules/Third/Third";
import Fourth from "../../molecules/Fourth/Fourth";
import Fifth from "../../molecules/Fifth/Fifth";
import Sixth from "../../molecules/Sixth/Sixth";
import Seventh from "../../molecules/Seventh/Seventh";
import Eighth from "../../molecules/Eighth/Eighth";
import Ninth from "../../molecules/Ninth/Ninth";
import Tenth from "../../molecules/Tenth/Tenth";
import Eleventh from "../../molecules/Eleventh/Eleventh";
import Twelfth from "../../molecules/Twelfth/Twelfth";


const InfoValidation = () => {
  const { t } = useTranslation();
  let location = useLocation();
  const navigateWithQuery = useNavigateWithQuery();
  const [id, setId] = useState("");
  const [formData, setFormData] = useState<Partial<Animal>>({});

  useEffect(() => {
    if (location && location.state) {
      if (location.state.formData) {
        setFormData(location.state.formData);
      }
      if (location.state.animalId) {
        setId(location.state.animalId);
      }
    } else {
      navigateWithQuery(AppRoutes.BASE_ROUTE);
    }
    // I removed location from the dependency because this value overwrote changes in the form every time. 
    // Without location in the dependency everything started working again
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Header formData={formData} id={id} timeLine={13}>
        <Box className="InfoValidation">
          <Title variant="h3">
            {t("animalInfo:PROFIL_VALIDATION.INDENTIFICATION_INFOS")}
          </Title>
          <Box className="dataDisplay">
            <First formData={formData} setFormData={setFormData} mode="validation" />
            <Seconde formData={formData} setFormData={setFormData} />
          </Box>
          <Title variant="h3">
            {t("animalInfo:PROFIL_VALIDATION.PERSONAL_INFOS")}
          </Title>
          <Box className="dataDisplay">
            <Third formData={formData} setFormData={setFormData} />
            <Fourth formData={formData} setFormData={setFormData} mode="validation" />
          </Box>
          <Title variant="h3">
            {t("animalInfo:PROFIL_VALIDATION.PHYSICAL")}
          </Title>
          <Box className="dataDisplay">
            <Fifth formData={formData} setFormData={setFormData} />
            <Sixth formData={formData} setFormData={setFormData} />
          </Box>
          <Title variant="h3">
            {t("animalInfo:PROFIL_VALIDATION.UNIQUE_IDENTIFICATION")}
          </Title>
          <Box className="dataDisplay">
            <Seventh formData={formData} setFormData={setFormData} mode="validation" />
          </Box>
          <Title variant="h3">
            {t("animalInfo:PROFIL_VALIDATION.MEDICAL_HISTORY")}
          </Title>
          <Box className="dataDisplay">
            <Eighth formData={formData} setFormData={setFormData} mode="validation" />
            <Ninth formData={formData} setFormData={setFormData} />
            <Tenth formData={formData} setFormData={setFormData} />
          </Box>
          <Title variant="h3">
            {t("animalInfo:PROFIL_VALIDATION.ACTIVITY")}
          </Title>
          <Box className="dataDisplay">
            <Eleventh formData={formData} setFormData={setFormData} mode="validation" />
          </Box>
          <Twelfth formData={formData} setFormData={setFormData} />
        </Box>
      </Header>
    </Container>
  );
};

export default InfoValidation;